<template>
    <svg class="w-full h-8" :class="color ? color : 'text-gray-800'" ref="waveWrapper">
        <g ref="group">
            <polyline class="stroke-current" :class="stroke ? stroke : 'stroke-w-1'" ref="wave" />
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        color: String,
        stroke: String,
        amplitude: Number,
        frequency: Number,
        segments: Number
    },

    data() {
        return {
            amp: 0
        };
    },

    mounted() {
        if (screen.width < 1024) {
            this.amp = this.amplitude / 2;
        } else {
            this.amp = this.amplitude;
        }

        const svg = this.$refs.waveWrapper;
        const wave = this.$refs.wave;
        const width = this.$refs.waveWrapper.clientWidth;

        const interval = width / this.segments;

        gsap.set(this.$refs.group, { y: 16 });

        for (let i = 0; i < this.segments; i++) {
            const norm = i / (this.segments - 1);
            const point = wave.points.appendItem(svg.createSVGPoint());

            point.x = i * interval;
            point.y = this.amp / 2;

            gsap.to(point, { y: -point.y, duration: 1, repeat: -1, yoyo: true, ease: 'sine.inOut' }).progress(
                norm * this.frequency
            );
        }
    }
};
</script>

<style lang="scss" scoped>
polyline {
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
}
</style>
